"use strict";
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
Object.defineProperty(exports, "__esModule", { value: true });
const React = require('react');
const react_obfuscate_1 = require("react-obfuscate");
const header_1 = require("./header");
require("./layout.css");
const Layout = ({ children, front }) => {
    return (React.createElement(React.Fragment, null,
        !front && React.createElement(header_1.default, { siteTitle: "jason.phillips" }),
        React.createElement("div", { style: {
                margin: `0 auto`,
                maxWidth: 960,
                padding: `0px 1.0875rem 1.45rem`,
                paddingTop: 0,
            } },
            React.createElement("main", { className: "max-w-screen-md" }, children),
            React.createElement("footer", { style: { marginTop: '1em', opacity: '0.6' } },
                React.createElement("hr", null),
                React.createElement(react_obfuscate_1.default, { style: { display: "inline-block" }, email: "jason.surname.phillips@gmail.com" })))));
};
exports.default = Layout;
